import React from 'react';
import { Divider } from 'antd';

import DepartmentUtilizationTable from '@totem/components/ticketing/employeeUtilization/departmentUtilizationTable';
import EmployeeUtilizationContainer from '@totem/components/ticketing/employeeUtilization/employeeUtilizationContainer';
import EmployeeUtilizationFilters from '@totem/components/ticketing/employeeUtilization/employeeUtilizationFilters';
import EmployeeUtilizationTable from '@totem/components/ticketing/employeeUtilization/employeeUtilizationTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const EmployeeUtilizationReportPage = () => {
  return (
    <ContentLayout>
      <EmployeeUtilizationContainer>
        <IBCard isCovered>
          <EmployeeUtilizationFilters />
          <Divider titlePlacement={'start'}>Employee Utilization</Divider>
          <EmployeeUtilizationTable />
          <Divider titlePlacement={'start'}>Department Utilization</Divider>
          <DepartmentUtilizationTable />
        </IBCard>
      </EmployeeUtilizationContainer>
    </ContentLayout>
  );
};

export default EmployeeUtilizationReportPage;
